var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: "绑定/解除账号",
        width: "434px",
        loading: _vm.loading,
        height: "auto",
        top: _vm.top,
      },
      on: { success: _vm.sure },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "switchOrg",
        },
        [
          _c(
            "div",
            { staticClass: "orgList" },
            [
              _vm.orgListFlag
                ? _vm._l(_vm.orgList, function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "orgItem" },
                      [
                        _c("div", { staticClass: "name" }, [
                          _vm._v(_vm._s(item.type === 1 ? "飞书" : "企微")),
                        ]),
                        _c("div", { staticClass: "name grow" }, [
                          _vm._v(_vm._s(item.name || "--")),
                        ]),
                        _c("div", { staticClass: "name grow phone" }, [
                          _vm._v(_vm._s(item.mobile || "--")),
                        ]),
                        _c(
                          "el-button",
                          {
                            staticClass: "block-btn",
                            attrs: {
                              size: "mini",
                              type: item.status ? "danger" : "primary",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.bingClick(item)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(item.status ? "解除绑定" : "绑定") +
                                " "
                            ),
                          ]
                        ),
                        _vm.organizationId === item.organizationId &&
                        item.status !== 1
                          ? _c("img", {
                              staticClass: "checkIcon",
                              attrs: {
                                src: require("@/assets/image/login/check.png"),
                                alt: "",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  })
                : [
                    _c("el-empty", {
                      attrs: {
                        "image-size": 100,
                        description: "未有待绑定/解除的账号",
                      },
                    }),
                  ],
            ],
            2
          ),
        ]
      ),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }